import React from 'react';
import PropTypes from 'prop-types';

export default class ShipmentOrderFormatter extends React.Component {
  static propTypes = {
    value: PropTypes.object.isRequired,
  };

  render() {
    return <div>{this.props.value.name}</div>;
  }
}
